import {
  OPEN_MI_CUSTOM_DATE_RANGE_MODAL,
  CLOSE_MI_CUSTOM_DATE_RANGE_MODAL,
  OPEN_MI_DETAILS_MODAL,
  CLOSE_MI_DETAILS_MODAL,
  GET_MI_DASHBOARD_REQUEST,
  GET_MI_DASHBOARD_SUCCESS,
  GET_MI_DASHBOARD_FAILURE,
  GET_MI_DASHBOARD_XLS_REQUEST,
  GET_MI_DASHBOARD_XLS_SUCCESS,
  GET_MI_DASHBOARD_XLS_FAILURE,
  RESET_MI_DASHBOARD
} from '../actions';

function reports(state = {
  isDateRangePickerShown: false,
  isGettingMiDashboard: false,
  isGettingMiDashboardXls: false,
  isMiDetailsModalShown: false,
  dateRangeFrom: '',
  dateRangeTo: '',
  miData: null
}, action) {
  switch (action.type) {
    case OPEN_MI_CUSTOM_DATE_RANGE_MODAL:
      return {
        ...state,
        isDateRangePickerShown: action.isDateRangePickerShown
      };
    case CLOSE_MI_CUSTOM_DATE_RANGE_MODAL:
      return {
        ...state,
        isDateRangePickerShown: action.isDateRangePickerShown,
        dateRangeFrom: action.dateRangeFrom,
        dateRangeTo: action.dateRangeTo
      };
    case OPEN_MI_DETAILS_MODAL:
      return {
        ...state,
        isMiDetailsModalShown: action.isMiDetailsModalShown
      };
    case CLOSE_MI_DETAILS_MODAL:
      return {
        ...state,
        isMiDetailsModalShown: action.isMiDetailsModalShown
      };
    case GET_MI_DASHBOARD_REQUEST:
      return {
        ...state,
        isGettingMiDashboard: action.isGettingMiDashboard,
        miData: action.miData,
        error: action.error
      };
    case GET_MI_DASHBOARD_SUCCESS:
      return {
        ...state,
        isGettingMiDashboard: action.isGettingMiDashboard,
        miData: action.miData
      };
    case GET_MI_DASHBOARD_FAILURE:
      return {
        ...state,
        isGettingMiDashboard: action.isGettingMiDashboard,
        error: action.error
      };
    case GET_MI_DASHBOARD_XLS_REQUEST:
      return {
        ...state,
        isGettingMiDashboardXls: action.isGettingMiDashboardXls
      };
    case GET_MI_DASHBOARD_XLS_SUCCESS:
      return {
        ...state,
        isGettingMiDashboardXls: action.isGettingMiDashboardXls
      };
    case GET_MI_DASHBOARD_XLS_FAILURE:
      return {
        ...state,
        isGettingMiDashboardXls: action.isGettingMiDashboardXls,
      };
    case RESET_MI_DASHBOARD:
      return {
        ...state,
        isDateRangePickerShown: action.isDateRangePickerShown,
        isGettingMiDashboard: action.isGettingMiDashboard,
        isGettingMiDashboardXls: action.isGettingMiDashboardXls,
        dateRangeFrom: action.dateRangeFrom,
        dateRangeTo: action.dateRangeTo,
        miData: action.miData,
        error: action.error
      };
    default:
      return state;
  }
}

export default reports;
